"use client";
import { useMediaQuery } from "../use-media-query/use-media-query.mjs";
//#region packages/@mantine/hooks/src/use-reduced-motion/use-reduced-motion.ts
function useReducedMotion(initialValue, options) {
	return useMediaQuery("(prefers-reduced-motion: reduce)", initialValue, options);
}
//#endregion
export { useReducedMotion };

//# sourceMappingURL=use-reduced-motion.mjs.map